import { Col, Row, Typography, Button, Space } from 'antd';
import React, { useRef } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { data } from '../lib/data';

const { Title } = Typography;

export default function RecentGame() {
  const rowRef = useRef(null);

  function scroll(direction) {
    if (rowRef.current) {
      const scrollAmount = 300;
      rowRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div style={{position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>Recent Games</Title>
        <Space>
          <Button 
            type="text" 
            icon={<LeftOutlined />} 
            onClick={() => scroll('left')}
            style={{ padding: '4px 8px' }}
          />
          <Button 
            type="text" 
            icon={<RightOutlined />} 
            onClick={() => scroll('right')}
            style={{ padding: '4px 8px' }}
          />
        </Space>
      </div>
      
      <div 
        ref={rowRef}
        style={{
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          whiteSpace: 'nowrap',
          padding: '8px 0',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        
        }}
      >
        <Row gutter={[16, 0]} style={{ display: 'inline-flex', flexWrap: 'nowrap' }}>
          {data.top_games.map((game) => (
            <Col key={game.game_id} style={{ flex: '0 0 auto' }}>
              <div 
                style={{
                  width: '95px',
                  height: '95px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  ':hover': {
                    transform: 'scale(1.05)'
                  }
                }}
              >
                <img 
                  src={game.icon_url} 
                  alt={game.game_name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
              
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}